import { useMutation } from '@tanstack/react-query';
import API from 'api/API';

export const useSaveAllTrayInspections = () => {
  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.deliveries.saveAllTrayInspections>) =>
      API.deliveries.saveAllTrayInspections(...args),
  });
};
